<div class="monitoring-filter-modal-container">
  <div class="filter-form">
    <button mat-stroked-button disableRipple [matMenuTriggerFor]="menu">
      <mat-icon>filter_list</mat-icon>
      Selecionar Filtros
    </button>

    <mat-menu
      #menu="matMenu"
      class="filtros-container"
      [overlapTrigger]="false"
      (click)="$event.stopPropagation()"
    >
      <ng-template matMenuContent>
        <div class="filtro-bloco">
          <!-- Cliente -->
          <mat-form-field
            class="filter-field"
            (click)="$event.stopPropagation()"
          >
            <mat-label>Cliente</mat-label>
            <input
              matInput
              [formControl]="getFormControl('organization')"
              [matAutocomplete]="autoOrg"
              (click)="$event.stopPropagation()"
              type="text"
              placeholder="Digite o nome do cliente"
            />
            @if (form.value.organization != undefined) {
              <button
                mat-icon-button
                matSuffix
                type="button"
                (click)="clearOrganizationField()"
                [attr.aria-label]="'Limpar cliente'"
              >
                <mat-icon>close</mat-icon>
              </button>
            }
            <mat-autocomplete
              #autoOrg="matAutocomplete"
              [displayWith]="displayOrganizationName"
            >
              <mat-option [value]="'__ALL__'">Todos</mat-option>
              <mat-option [value]="'Geoambiente'">Geoambiente</mat-option>
              @for (org of filteredOrganizations; track org.id) {
                <mat-option [value]="org">{{ org.name }}</mat-option>
              }
            </mat-autocomplete>
          </mat-form-field>
        </div>

        <div class="filtro-bloco">
          <!-- Safra -->
          <mat-form-field
            class="filter-field"
            (click)="$event.stopPropagation()"
          >
            <mat-label>Safra</mat-label>
            <mat-select
              [formControl]="getFormControl('safra')"
              (click)="$event.stopPropagation()"
            >
              <mat-option value="">Todas</mat-option>
              @for (cropPeriod of cropPeriods; track $index) {
                <mat-option [value]="cropPeriod">{{ cropPeriod }}</mat-option>
              }
            </mat-select>
          </mat-form-field>
        </div>

        <div class="filtro-bloco">
          <!-- Cultura -->
          <mat-form-field
            class="filter-field"
            (click)="$event.stopPropagation()"
          >
            <mat-label>Cultura</mat-label>
            <mat-select
              [formControl]="getFormControl('cultura')"
              (click)="$event.stopPropagation()"
            >
              <mat-option value="">Todas</mat-option>
              @for (cropCulture of cropCultures; track $index) {
                <mat-option [value]="cropCulture">{{
                  cropCulture.description
                }}</mat-option>
              }
            </mat-select>
          </mat-form-field>
        </div>

        <div class="filtro-bloco">
          <!-- Status -->
          <mat-form-field
            class="filter-field"
            (click)="$event.stopPropagation()"
          >
            <mat-label>Status</mat-label>
            <mat-select
              [formControl]="getFormControl('status')"
              (click)="$event.stopPropagation()"
            >
              <mat-option value="">Todos</mat-option>
              @for (statusOption of statusOptions; track statusOption.value) {
                <mat-option [value]="statusOption.value">{{
                  statusOption.label
                }}</mat-option>
              }
            </mat-select>
          </mat-form-field>
        </div>

        <div class="filtro-acoes">
          <button
            mat-button
            class="clear-btn"
            (click)="clearFilters(); $event.stopPropagation()"
          >
            Limpar
          </button>
          <button mat-button class="cancel-btn" (click)="cancel()">
            Cancelar
          </button>
          <button mat-flat-button class="apply-btn" (click)="applyFilters()">
            Aplicar
          </button>
        </div>
      </ng-template>
    </mat-menu>
  </div>
</div>
